/* Pongfinity Kit landing — behaviour shared by every pfk-* section.
   Section-specific behaviour (gallery, lightbox, marquee, review toggle,
   sticky bar) lives inside the section that owns it. */
(function () {
  /* every pfk-* section links this file, so bail out after the first run */
  if (window.__pfkLandingInit) return;
  window.__pfkLandingInit = true;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on scroll */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    document.querySelectorAll('.pf-landing .reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.pf-landing .reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* clips play muted while they're on screen, pause when they're not */
  var vids = document.querySelectorAll('.pf-landing video[data-autoplay]');
  if (vids.length && 'IntersectionObserver' in window && !reduce) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: .4 });
    vids.forEach(function (v) { vio.observe(v); });
  }
})();
